import React from "react";
import { useTranslation } from "react-i18next";
import TrackedAccounts from "../components/TrackedAccounts";

const TrackedAccountsPage = () => {
  const { t } = useTranslation();

  return (
    <div className="container-fluid pt-4 mt-3">
      <h4 className="mb-4" style={{ color: 'var(--text-primary)' }}>
        {t("tracked_accounts_menu")}
      </h4>
      <TrackedAccounts />
    </div>
  );
};

export default TrackedAccountsPage;
